<script lang="ts">
  import { clickOutside } from '../../../../utils/clickOutside.js';
  import MainMenuPopup from '../../../../components/popups/MainMenuPopup.svelte';
  import { user as storeUser } from '../../../../store/auth.store';

  export let selectedPageIndex = -1;
  export let tutorialStep = 0;
  export let tutorialNumber = 0;
  export let signatureMenu = false;
  export let packetMenu = false;
  export let addTextMenu = false;
  export let quickSigns = [];
  export let blog;
  export let templates = [];
  export let multiplePdfs = [];
  export let entry_requireds = [];
  export let entry_options = [];
  export let pdfName = '';
  export let user;
  export let newProfilePanel = false;
  export let searchKeyPending = '';
  export let pendingSignature = [];
  export let signatureTabLoading = true;
  export let friends = [];
  export let showArchive = false;
  export let completedSignature = [];
  export let emailNotifyAvailable = true;
  export let searchKeyCompleted = '';
  export let completedArchived = [];
  export let sendToId = 0;
  export let showSignatureTab = false;
  export let completedPDFUrl = '';
  export let loadingTemplate = false;
  export let chatUsers = [];
  export let users = [];
  export let merusToken = '';
  export let pdfFile;
  export let pages = [];
  export let allObjects = [];
  export let pagesScale = [];
  export let editTemplatesAvailable = false;
  export let processingSaveTemplate = false;
  export let completedSaveTemplate = false;
  export let selectedMerusUserId = '';
  export let selectedMerusActivityTypeId = '';
  export let selectedSharepoint = '';
  export let signColor = 0;
  export let templateId = 0;
  export let pdfBlobFile = '';
  export let pdfFiles = [];
  export let tempThumb = '';
  export let sendPDFType = '';
  export let layerPos = { x: 0, y: 0 };
  export let currentFont = 'Times-Roman';
  export let teamViewCompletedDocAvailable = false;
  export let shareSettingsAvailable = false;
  export let searchKeyFriend = '';
  export let inviteFriendPanel = false;
  export let inviteClipboardTxt = '';
  export let clipboardTxt = '';
  export let merusCaseEnabled = false;
  export let fileVineEnabled = false;
  export let fluentCaseEnabled = false;
  export let fluentCaseToken = '';
  export let microsoftSharepointTenantId = '';
  export let activeTab;
  export let emailSubject = '';
  export let twilioEnabled = false;

  export let displayLeftMenuFunc;
  export let openLeftMenu;
  export let closeLeftMenu;
  export let onUploadPDF;
  export let onUploadImage;
  export let showPacketMenu;
  export let showAddTextMenu;
  export let showSignatureMenu;
  export let onAddDrawing;
  export let addSignImage;
  export let addQuickSignImage;
  export let addTextField;
  export let handleClickOutsideSignatureMenu;
  export let handleClickOutsideAddTextMenu;
  export let deleteTemplate;
  export let loadExtraTemplate;
  export let shareFunc;
  export let showNewProfileFunc;
  export let showLoginPopup;
  export let handleLoadTemplate;
  $: currentUser = ($storeUser && $storeUser.id) ? $storeUser : (user || {});
</script>

<div
  class="sign-editor-header fixed z-10 top-0 left-0 right-0 flex justify-center items-center
    bg-gray-200 border-b border-gray-300"
  data-testid="sign-editor-header"
>
  <div
    on:click={displayLeftMenuFunc}
    on:mouseenter={() => {
      // Desktop hover-open only — mouseover+toggle reopened the sidebar on mobile
      if (typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches) {
        if (typeof openLeftMenu === 'function') openLeftMenu();
      }
    }}
    class="sign-editor-header__brand flex items-center justify-center"
    data-testid="left-menu-brand"
    role="button"
    tabindex="0"
  >
    <img
      src="img/signAsset.svg"
      alt="Sign"
      class="sign-editor-header__brand-icon"
    />
    <span class="sign-editor-header__brand-text">Sign</span>
  </div>
  <input
    type="file"
    name="pdf"
    id="pdf"
    on:change={onUploadPDF}
    class="hidden"
  />
  <input
    type="file"
    id="image"
    name="image"
    class="hidden"
    on:change={onUploadImage}
  />
  <div
    class="sign-editor-header__tools relative mr-3 flex h-8 bg-gray-400 rounded-sm
      md:mr-4"
  >
    <label
      class="flex items-center justify-center h-full w-8 hover:bg-gray-500
    cursor-pointer"
      class:cursor-not-allowed={selectedPageIndex < 0}
      class:bg-gray-500={selectedPageIndex < 0}
      on:click={showPacketMenu}
    >
      <img
        src="file-black-icon.svg"
        alt="An icon for adding"
        style="width: 17px;"
      />
    </label>
    {#if selectedPageIndex < 0}
      <label
        class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
        class:cursor-not-allowed={selectedPageIndex < 0}
        class:bg-gray-500={selectedPageIndex < 0}
      >
        <img src="image.svg" alt="An icon for adding images" />
      </label>
    {:else}
      <label
        class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
        for="image"
        class:cursor-not-allowed={selectedPageIndex < 0}
        class:bg-gray-500={selectedPageIndex < 0}
      >
        <img src="image.svg" alt="An icon for adding images" />
      </label>
    {/if}
    <label
      class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
      class:border-green={(tutorialStep == 4 && tutorialNumber == 0) || (tutorialStep == 3 && tutorialNumber == 2)}
      class:cursor-not-allowed={selectedPageIndex < 0}
      class:bg-gray-500={selectedPageIndex < 0}
      on:click={showAddTextMenu}
      data-testid="add-text-menu-button"
    >
      <img src="text.svg" alt="An icon for adding text" />
    </label>
    <label
      class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
      on:click={showSignatureMenu}
      class:border-green={tutorialStep == 3 && (tutorialNumber === 0 || tutorialNumber === 1|| tutorialNumber === 2)}
      class:cursor-not-allowed={selectedPageIndex < 0}
      class:bg-gray-500={selectedPageIndex < 0}
      data-testid="signature-menu-button"
    >
      <img src="gesture.svg" alt="An icon for adding drawing" />
    </label>
    {#if signatureMenu}
      <div
        class="sign-header-dropdown bg-gray-200 border-b border-gray-300 py-1 px-2 rounded"
        style="position: absolute; left: 0; top: 50px;width: 190px;"
        data-testid="signature-menu-dropdown"
        use:clickOutside
        on:click_outside={handleClickOutsideSignatureMenu}
      >
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={onAddDrawing}
        >
          <img
            src="draw.svg"
            alt="Draw Signature"
            class="mr-3"
            style="width: 24px;"
          /> <span>Draw Signature</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          class:border-green={tutorialStep == 3 && (tutorialNumber === 0 || tutorialNumber === 1 || tutorialNumber === 2)}
          on:click={() => addSignImage("", 0)}
        >
          <img
            src="3p.svg"
            alt="Get Signature"
            class="mr-3"
            style="width: 24px;"
          /> <span>Get Signature</span>
        </label>
        <label class="flex items-center py-1 h-full">
          <img
            src="save.svg"
            alt="Saved Signature"
            class="mr-3"
            style="width: 24px;"
          /> <span>Saved Signature</span>
        </label>
        {#each quickSigns as sign}
          <label
            class="flex items-center py-1 h-full hover:bg-gray-500 px-2
              cursor-pointer"
            on:click={() => addQuickSignImage(blog.siteurl + sign.image, 0)}
            style="margin-left: 25px;"
          >
            <span>- {sign.name}</span>
          </label>
        {/each}
      </div>
    {/if}
    {#if packetMenu}
    <div
      class="sign-header-dropdown bg-gray-200 border-b border-gray-300 py-2 px-2 rounded"
      style="position: absolute; left: 0; top: 50px; width: 280px;" 
      use:clickOutside
      on:click_outside={handleClickOutsideSignatureMenu}
    >
      <div
        class="grid grid-cols-2 gap-2" 
        style="max-height: 50vh; overflow-y: auto;"
      >
        {#each templates as template}
          <div class="flex flex-col items-center gap-1 bg-gray-50 p-2 rounded hover:bg-gray-100 relative min-h-[120px]">
            <img
              src="/delete.svg"
              alt="delete"
              aria-label="Delete Template"
              class="w-4 h-4 opacity-70 hover:opacity-100 absolute top-2 right-2 {!(template.loaded && multiplePdfs.length > 1) ? 'hidden' : ''}"
              on:click|stopPropagation={() => deleteTemplate(template)}
            />
            <img
              src={template.thumbnail}
              alt="template"
              class="w-[60px] h-auto rounded border border-gray-300 cursor-pointer"
              on:click={() => loadExtraTemplate(template)}
            />
            <div
              class="text-[11px] text-center break-words w-full cursor-pointer px-1 font-medium"
              on:click={() => loadExtraTemplate(template)}
            >
              {template.pdfName}
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/if}


    {#if addTextMenu}
        <div
        class="sign-header-dropdown bg-gray-200 border-b border-gray-300 py-1 px-2 rounded"
        style="position: absolute; left: 0; top: 50px;width: 190px;"
        data-testid="add-text-menu-dropdown"
        use:clickOutside
        on:click_outside={handleClickOutsideAddTextMenu}
      >
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Initial", true)}
        >
          <span>Initial</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Date", true)}
        >
          <span>Date</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Name", true)}
        >
          <span>Name</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Phone_Number", true)}
        >
          <span>Phone</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("New Text Field", true)}
        >
          <span>Text</span>
        </label>
        <label 
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Entry Required", true)}
        >
          <span>Entry(required)</span>
        </label>
        {#each entry_requireds as object}
          <label
            class="flex items-center py-1 h-full hover:bg-gray-500 px-2
              cursor-pointer"
            on:click={() => addTextField(object.text, true)}
            style="margin-left: 25px;"
          >
            <span>- {object.lines[0]}</span>
          </label>
        {/each}
        <label 
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Entry Optional", true)}
        >
          <span>Entry(optional)</span>
        </label>
        {#each entry_options as object}
          <label
            class="flex items-center py-1 h-full hover:bg-gray-500 px-2
              cursor-pointer"
            on:click={() => addTextField(object.text, true)}
            style="margin-left: 25px;"
          >
            <span>- {object.lines[0]}</span>
          </label>
        {/each}

      </div>
    {/if}
  
  
    <!-- {#if addTextMenu}
      <div
      class="bg-gray-200 border-b border-gray-300 py-1 px-2 rounded"
      style="position: absolute; left: 0; top: 50px;width: 190px;"
      use:clickOutside
      on:click_outside={handleClickOutsideSignatureMenu}
      >
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Initial", true)}
        >
        <span>Initial</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Date", true)}
          >
          <span>Date</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Name", true)}
          >
          <span>Name</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Phone_Number", true)}
          >
          <span>Phone</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("New Text Field", true)}
          >
          <span>Text</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Entry Required", true)}
          >
          <span>Entry(required)</span>
        </label>
        <label
          class="flex items-center py-1 h-full hover:bg-gray-500
            cursor-pointer"
          on:click={() => addTextField("Entry Optional", true)}
          >
          <span>Entry(optional)</span>
        </label>
      </div>
    {/if} -->
  

  
  
  
  
  
  </div>
  <div class="justify-center mr-2 md:mr-4 w-full max-w-xs hidden md:flex">
    <img src="/edit.svg" class="mr-2" alt="a pen, edit pdf name" />
    <input
      placeholder="Rename your PDF here"
      type="text"
      class="flex-grow bg-transparent"
      bind:value={pdfName}
    />
  </div>
  {#if currentUser && currentUser.id != ""}
    <button
      on:click={shareFunc}
      data-testid="share-button"
      class="sign-editor-header__share w-16 md:w-20 text-white font-bold py-1 px-2
      md:px-4 mr-2 md:mr-4 rounded text-sm md:text-base"
      class:border-green={tutorialStep == 5 && (tutorialNumber === 0 || tutorialNumber === 1)}
      class:cursor-not-allowed={selectedPageIndex < 0}
      class:bg-gray-500={selectedPageIndex < 0}
      class:bg-blue-500={selectedPageIndex >= 0}
      class:hover:bg-blue-700={selectedPageIndex >= 0}
    >
      SHARE
    </button>
  {:else}
    <button
      class="sign-editor-header__share w-16 md:w-20 text-white font-bold py-1 px-2
      md:px-4 mr-2 md:mr-4 rounded cursor-not-allowed bg-gray-500 text-sm md:text-base"
      class:border-green={tutorialStep == 5 && (tutorialNumber === 0 || tutorialNumber === 1)}
    >
      SHARE
    </button>
  {/if}
  {#if currentUser && currentUser.id != ""}
    <!-- <div class="relative">
      <label
        class="flex items-center justify-center h-full md:flex cursor-pointer"
        on:click={showlogoutpanel}
      >
        {user.name}
      </label>
      {#if logoutpanel}
        <label
          class="whitespace-no-wrap round py-1 px-3 cursor-pointer"
          on:click={logoutFunc}
          use:clickOutside
          on:click_outside={handleClickOutsideLogoutPanel}
          style="position: absolute; background: #edf2f7; top: 50px; left: 0;"
        >
          Log out
        </label>
      {/if}
    </div> -->
    <div class="sign-editor-header__profile-wrap">
      <button
        on:click={showNewProfileFunc}
        data-testid="profile-button"
        class="sign-editor-header__profile flex items-center justify-center md:flex"
        class:border-green={tutorialStep == 6 && (tutorialNumber === 0 || tutorialNumber === 1) || (tutorialStep == 4 && (tutorialNumber === 2)|| (tutorialStep == 2 && (tutorialNumber === 4 || tutorialNumber === 5 || tutorialNumber === 6 || tutorialNumber === 7)))}
      >
        <!-- <img alt="" src="/menu.png" /> -->
        <!-- {user.name} -->
        {#if user.img != ""}
          <img
            class="chat-page-header__user-icon"
            src={currentUser.img}
            alt="User"
          />
        {:else}
          <img
            class="chat-page-header__user-icon"
            src="/account_icon.png"
            alt="User"
          />
        {/if}
      </button>
    </div>

      <MainMenuPopup 
        bind:user={user} 
        bind:newProfilePanel={newProfilePanel}
        bind:searchKeyPending={searchKeyPending}
        bind:pendingSignature={pendingSignature}
        bind:signatureTabLoading={signatureTabLoading}
        bind:friends={friends}
        bind:showArchive={showArchive}
        bind:completedSignature={completedSignature}
        bind:templates={templates}
        bind:emailNotifyAvailable={emailNotifyAvailable}
        bind:searchKeyCompleted={searchKeyCompleted}
        bind:completedArchived={completedArchived}
        bind:sendToId={sendToId}
        bind:showSignatureTab={showSignatureTab}
        bind:completedPDFUrl={completedPDFUrl}
        bind:selectedPageIndex={selectedPageIndex}
        bind:pdfName={pdfName}
        bind:loadingTemplate={loadingTemplate}
        bind:chatUsers={chatUsers}
        bind:users={users}
        bind:merusToken={merusToken}
        bind:pdfFile={pdfFile}
        bind:pages={pages}
        bind:allObjects={allObjects}
        bind:pagesScale={pagesScale}
        bind:quickSigns={quickSigns}
        bind:editTemplatesAvailable={editTemplatesAvailable}
        bind:processingSaveTemplate={processingSaveTemplate}
        bind:multiplePdfs={multiplePdfs}
        bind:completedSaveTemplate={completedSaveTemplate}
        bind:selectedMerusUserId={selectedMerusUserId}
        bind:selectedMerusActivityTypeId={selectedMerusActivityTypeId}
        bind:selectedSharepoint={selectedSharepoint}
        bind:signColor={signColor}
        bind:templateId={templateId}
        bind:pdfBlobFile={pdfBlobFile}
        bind:pdfFiles={pdfFiles}
        bind:tempThumb={tempThumb}
        bind:sendPDFType={sendPDFType}
        bind:layerPos={layerPos}
        bind:addTextMenu={addTextMenu}
        bind:currentFont={currentFont}
        bind:signatureMenu={signatureMenu}
        bind:teamViewCompletedDocAvailable={teamViewCompletedDocAvailable}
        bind:shareSettingsAvailable={shareSettingsAvailable}
        bind:searchKeyFriend={searchKeyFriend}
        bind:inviteFriendPanel={inviteFriendPanel}
        bind:inviteClipboardTxt={inviteClipboardTxt}
        bind:clipboardTxt={clipboardTxt}
        bind:merusCaseEnabled={merusCaseEnabled}
        bind:fileVineEnabled={fileVineEnabled}
        bind:fluentCaseEnabled={fluentCaseEnabled}
        bind:fluentCaseToken={fluentCaseToken}
        bind:microsoftSharepointTenantId={microsoftSharepointTenantId}
        bind:activeTab={activeTab}
        bind:tutorialStep={tutorialStep}
        bind:tutorialNumber={tutorialNumber}
        bind:emailSubject={emailSubject}
        bind:twilioEnabled={twilioEnabled}
        on:select={handleLoadTemplate}
      />
  {:else}
    <button
      on:click={showLoginPopup}
      class="w-20 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3
        md:px-4 mr-3 md:mr-4 rounded"
    >
      Login
    </button>
  {/if}
</div>

<style>
  .sign-editor-header {
    height: 4rem;
    padding: 0 0.5rem;
    gap: 0.25rem;
  }

  .sign-editor-header__brand {
    position: absolute;
    left: 12px;
    cursor: pointer;
  }

  .sign-editor-header__brand-icon {
    margin-right: 6px;
    max-width: 28px;
    width: 100%;
  }

  .sign-editor-header__brand-text {
    font-weight: 600;
    font-size: 0.95rem;
  }

  @media (max-width: 767px) {
    .sign-editor-header {
      height: 3rem;
      padding: 0 0.35rem 0 2.5rem;
      justify-content: flex-end;
      align-items: center;
      gap: 0.3rem;
      overflow: visible;
      max-width: 100vw;
    }

    .sign-editor-header__brand {
      left: 6px;
      z-index: 2;
      min-width: 28px;
      min-height: 28px;
    }

    .sign-editor-header__brand-text {
      display: none;
    }

    .sign-editor-header__brand-icon {
      max-width: 20px;
      margin-right: 0;
    }

    /* Compact control size — tools + SHARE + profile */
    .sign-editor-header__tools {
      height: 28px !important;
      margin-right: 0 !important;
      border-radius: 5px !important;
      overflow: visible;
      flex-shrink: 0;
      align-items: stretch;
    }

    /* Direct tool icons only — do not shrink dropdown menu labels */
    .sign-editor-header__tools > :global(label) {
      width: 28px !important;
      min-width: 28px !important;
      max-width: 28px !important;
      height: 28px !important;
      min-height: 28px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .sign-editor-header__tools > :global(label) :global(img) {
      width: 15px !important;
      height: 15px !important;
      object-fit: contain;
    }

    .sign-editor-header__share {
      width: auto !important;
      min-width: 52px;
      height: 28px !important;
      min-height: 28px !important;
      max-height: 28px !important;
      padding: 0 10px !important;
      margin: 0 !important;
      font-size: 0.68rem !important;
      letter-spacing: 0.02em;
      line-height: 1 !important;
      font-weight: 700;
      border-radius: 5px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex-shrink: 0;
      box-sizing: border-box;
    }

    .sign-editor-header__profile-wrap {
      width: 28px !important;
      height: 28px !important;
      min-width: 28px !important;
      min-height: 28px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .sign-editor-header [data-testid='profile-button'] {
      width: 28px !important;
      height: 28px !important;
      min-width: 28px !important;
      min-height: 28px !important;
      margin: 0 !important;
      padding: 0 !important;
      border-radius: 50% !important;
      flex-shrink: 0;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      overflow: hidden;
      line-height: 0 !important;
    }

    .sign-editor-header [data-testid='profile-button'] :global(img),
    .sign-editor-header [data-testid='profile-button'] img {
      width: 28px !important;
      height: 28px !important;
      object-fit: cover;
      display: block;
    }
  }

  /* Galaxy S8 / narrow phones (~360px) */
  @media (max-width: 380px) {
    .sign-editor-header {
      padding: 0 0.25rem 0 2.25rem;
      gap: 0.25rem;
    }

    .sign-editor-header__tools > :global(label) {
      width: 26px !important;
      min-width: 26px !important;
      max-width: 26px !important;
    }

    .sign-editor-header__share {
      min-width: 48px;
      padding: 0 8px !important;
      font-size: 0.65rem !important;
    }
  }
</style>
